module.exports = __webpack_public_path__ + "assets/img/gif-1.fcafc743.jpg";